import React, { FC } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import { useAssessmentPortalState } from '../../../assessment-portal';
import DetailsPage from '../details-page';
import { buildDraftPayload, syncDraftWorkflow } from '../../utils/draft-workflow';
import type { AdhdFlowState, PatientInfoValues } from '../../types/flow';

const DetailsStep: FC<StepPageProps> = ({ defaultValues, onBack, onNext }) => {
  const { flowState } = useAssessmentPortalState<AdhdFlowState>();

  // Not awaited: the patient moves on while the draft is saved; confirm waits for it.
  const handlePersonalInfoComplete = (values: PatientInfoValues) => {
    syncDraftWorkflow(buildDraftPayload(flowState, values));
  };

  return (
    <DetailsPage
      defaultValues={defaultValues}
      onBack={onBack}
      onNext={onNext}
      onPersonalInfoComplete={handlePersonalInfoComplete}
    />
  );
};

export default DetailsStep;
